module.exports = __webpack_public_path__ + "assets/img/behaviorAnalysis.a4363454.png";